import React, { useState } from 'react';
import { FaWhatsapp, FaTelegramPlane, FaFacebook, FaTwitter, FaLinkedin, FaQrcode } from 'react-icons/fa';
import QRCodeModal from './QRCodeModal';

const ShareSyntaxe = ({ syntax, network }) => {
  const [showQRCodeModal, setShowQRCodeModal] = useState(false);

  const shareOn = (platform) => {
    let url = '';
    const encodedText = encodeURIComponent(`Cette syntaxe de «${network.name}» pourrait vous être utile :\n\n${syntax.title}\n${syntax.content}\n\nPartagez-la à vos amis !`);
    const encodedUrl = encodeURIComponent(window.location.href);

    switch (platform) {
      case 'whatsapp':
        url = `https://wa.me/?text=${encodedText} ${encodedUrl}`;
        break;
      case 'telegram':
        url = `https://t.me/share/url?url=${encodedUrl}&text=${encodedText}`;
        break;
      case 'facebook':
        url = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
        break;
      case 'twitter':
        url = `https://x.com/intent/tweet?text=${encodedText}&url=${encodedUrl}`;
        break;
      case 'linkedin':
        url = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`;
        break;
      default:
        return;
    }

    window.open(url, '_blank');
  };

  const toggleQRCodeModal = () => {
    setShowQRCodeModal(!showQRCodeModal);
  };

  return (
    <div className="flex flex-col items-center">
      <div className="flex space-x-2">
        <FaWhatsapp className="text-green-500 cursor-pointer" size={18} onClick={() => shareOn('whatsapp')} />
        <FaTelegramPlane className="text-blue-500 cursor-pointer" size={18} onClick={() => shareOn('telegram')} />
        <FaFacebook className="text-blue-600 cursor-pointer" size={18} onClick={() => shareOn('facebook')} />
        <FaTwitter className="text-blue-400 cursor-pointer" size={18} onClick={() => shareOn('twitter')} />
        <FaLinkedin className="text-blue-700 cursor-pointer" size={18} onClick={() => shareOn('linkedin')} />
        <FaQrcode className="text-gray-500 cursor-pointer" size={18} onClick={toggleQRCodeModal} />
      </div>
      {showQRCodeModal && (
        <QRCodeModal syntax={syntax} networkName={network.name} onClose={toggleQRCodeModal} />
      )}
    </div>
  );
};

export default ShareSyntaxe;
